import { useContext, useEffect } from 'react';
import { AuthContext } from '../../contexts/Auth';
import { isAuthorized } from '../../helpers/authorization';
import { TENANT_ADMIN } from '../../constants/roles';

export default function ChatBubble() {
    const { state } = useContext(AuthContext);

    useEffect(() => {
        // Only inject scripts if user is authenticated and has TENANT_ADMIN role
        if (state.user && state.user.roles && isAuthorized(state.user.roles, [TENANT_ADMIN])) {
            // Create the chatBubbleRoot div if it doesn't exist
            if (!document.getElementById('chatBubbleRoot')) {
                const chatBubbleRoot = document.createElement('div');
                chatBubbleRoot.setAttribute('id', 'chatBubbleRoot');
                document.body.appendChild(chatBubbleRoot);
            }

            // Set the agx configuration
            window.agx = '674517d6ff4639de5e8a91782ZrR8zTlueN2mNeFQD7Hvg==|BooPcnAlw8tUflyDwssIxVeWjLvRtImOsylEcetIjgk=';

            // Create and inject the script tag
            const script = document.createElement('script');
            script.defer = true;
            script.src = 'https://storage.googleapis.com/agentx-cdn-01/agentx-chat.js';
            document.body.appendChild(script);

            // Cleanup function to remove scripts when component unmounts
            return () => {
                const existingScript = document.querySelector('script[src="https://storage.googleapis.com/agentx-cdn-01/agentx-chat.js"]');
                if (existingScript) {
                    existingScript.remove();
                }
                const chatBubbleRoot = document.getElementById('chatBubbleRoot');
                if (chatBubbleRoot) {
                    chatBubbleRoot.remove();
                }
                delete window.agx;
            };
        }
    }, [state.user]);

    // This component doesn't render anything visible
    return null;
}
